import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'reminderSchedules',
    collectionActionName: 'REMINDER_SCHEDULES',
    itemActionName: 'REMINDER_SCHEDULE',
});
